import React from "react";
import HeaderThree from "../../Layouts/Headers/HeaderThree";
import FooterOne from "../../Layouts/Footers/FooterOne";
import MainWid from "./MainWid";
import BrandAreaWid from "../../Common/BrandAreaWid";
// import InnerPageTitle from "../../Helpers/InnerPageTitle";

function ServiceDetails() {
  return (
    <>
      <HeaderThree />
      <main>
        
        {/* <InnerPageTitle
          title="Service Details"
          paths={[
            { name: "Home", path: "/" },
            { name: "Services", path: "/services" },
            { name: "Service Details", path: "/services/services-details" },
          ]}
        /> */}
        <MainWid />
        <BrandAreaWid className="pt-0" />
      </main>
      <FooterOne />
    </>
  );
}

export default ServiceDetails;
